export const uploadDemoGraphicConstants = {
    REQUEST_UPLOAD_CSV: 'REQUEST_UPLOAD_CSV',
    RECIEVE_UPLOAD_CSV: 'RECIEVE_UPLOAD_CSV',
    ERROR_UPLOAD_CSV: 'ERROR_UPLOAD_CSV'
} 


// WEBPACK FOOTER //
// ./src/_constants/uploadDemographic.constants.js